import '../../../styles/index.css'
import './PreçoPrincipal.css';
import { formataPreço } from '../../../utils/preços';

function PreçoPrincipal({preço, preçoParcelado}) {
  return (
    <section>
        {
        preçoParcelado ? (
        <>
          <h3 className='preço'>{`R$ ${formataPreço(preço.replace('.', ','))}`}</h3>
          <p className='b3 preçoParcelado'>{`ou 10x de R$ ${(parseFloat(preçoParcelado) / 10).toFixed(2).replace('.', ',')}`}</p>
        </>
        ) : (<h3 className='preço'>{`R$ ${formataPreço(preço.replace('.', ','))}`}</h3>)
      } 
    </section>
  );
}

export default PreçoPrincipal;
